import { Component } from 'react';
import styled from 'styled-components';
import { media } from '../../../styles';
import academyStyles from './academy-styles';

export default class AcademyThemeContent extends Component {
  render() {
    const contentClasses = this.getContentClasses();

    return (
      <AcademyContentWrapper className="academy-content-wrapper" $extraWidthPadding={this.props.extraWidthPadding}>
        <AcademyContent
          className={contentClasses.join(' ')}
          $hasBreadcrumbs={this.props.hasBreadcrumbs}
          style={this.props.style || {}}
        >
          {this.props.children}
        </AcademyContent>
      </AcademyContentWrapper>
    );
  }

  getContentClasses = () => ['academy-content'];
}

const AcademyContentWrapper = styled.div`
  padding: 0 ${(props) => (props.$extraWidthPadding ? '10rem' : '4rem')};

  ${media.desktopMedium} {
    padding: 0 ${(props) => (props.$extraWidthPadding ? '6rem' : '4rem')};
  }

  ${media.mobile} {
    padding-left: 2rem;
    padding-right: 2rem;
  }
`;

const AcademyContent = styled.div`
  padding: 60px 0;
  max-width: ${academyStyles.common.maxWidth}px;
  margin: 0 auto;

  ${(props) => props.$hasBreadcrumbs && 'padding-top: 30px;'}
`;
